import { FAQPageJsonLd } from 'next-seo';

interface FAQPageJsonLdCProps {
	items: any[];
}

interface Question {
	questionName: string;
	acceptedAnswerText: string;
}

const FAQPageJsonLdC = (props: FAQPageJsonLdCProps) => {
	const convertItems = () => {
		let items: Question[] = [];

		props.items.forEach((item: any) => {
			return items.push({
				questionName: item.title,
				acceptedAnswerText: item.answer.replace(/<\/?p[^>]*>/g, ''),
			});
		});

		return items;
	};

	return <FAQPageJsonLd mainEntity={convertItems()} />;
};

export default FAQPageJsonLdC;
